import {mediaflyTheme} from '@components/@theme/mediaflyTheme';
import customTheme from 'styles/theme';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Colors are defined in our app through 3 separate ways.
 * - CSS Variables
 * - muiv0 theme
 * - muiv4 theme
 *
 * These methods should handle swapping them all
 */

// TODO Inline usages
export function getMuiV4Theme() {
  return mediaflyTheme;
}

const mfThemeMuiV0 = merge(cloneDeep(customTheme), {
  palette: {
    primary1Color: mediaflyTheme.palette.primary.main,
    primary2Color: mediaflyTheme.palette.primary.main,
    flamingo: mediaflyTheme.palette.primary.main,
  },
});
// TODO Inline usages
export function getMuiV0Theme() {
  return mfThemeMuiV0;
}
